import { PromotionPlanEnum } from '#lib/enums'
import { PromotionIdEnum, PromotionRouteEnum, RoutesEnum } from '~/enums'
import type {
  HomePromotionItem,
  PromotionBannerItem,
  PromotionDeposit,
} from '~/types/promotion'

export const promotionItems: HomePromotionItem[] = [
  {
    name: 'Khai trương hồng phát',
    imgSrc: '/images/home/promotion/nohu.webp',
    imgSrcMB: '/images/home/promotion/nohu-mb.webp',
    to: PromotionRouteEnum.SanSieuHutPromotion,
    packageId: PromotionIdEnum.NOHU,
  },
  {
    name: 'Thưởng 150% lần nạp đầu tiên',
    imgSrc: '/images/home/promotion/first-promotion.webp',
    imgSrcMB: '/images/home/promotion/first-promotion-mb.webp',
    to: PromotionRouteEnum.FirstDepositPromotion,
    packageId: PromotionPlanEnum.WELCOME,
  },
  {
    name: 'Thưởng 70% nạp lần 2',
    imgSrc: '/images/home/promotion/second-promotion.webp',
    imgSrcMB: '/images/home/promotion/second-promotion-mb.webp',
    to: PromotionRouteEnum.SecondDepositPromotion,
    packageId: PromotionPlanEnum.PROMOTION,
  },
  {
    name: 'Hoàn trả 1.2%',
    imgSrc: '/images/home/promotion/refund-promotion.webp',
    imgSrcMB: '/images/home/promotion/refund-promotion-mb.webp',
    to: PromotionRouteEnum.UnlimitedDepositPromotion,
    packageId: PromotionPlanEnum.COMMISSION,
  },
]

export const promotionModalItems: HomePromotionItem[] = [
  {
    name: 'Thưởng 150% lần nạp đầu tiên',
    imgSrc: '/images/home/promotion/first-promotion-modal.webp',
    imgSrcMB: '/images/home/promotion/first-promotion-modal-mb.webp',
    to: PromotionRouteEnum.FirstDepositPromotion,
    packageId: PromotionPlanEnum.WELCOME,
  },
  {
    name: 'Thưởng 70% nạp lần 2',
    imgSrc: '/images/home/promotion/second-promotion-modal.webp',
    imgSrcMB: '/images/home/promotion/second-promotion-modal-mb.webp',
    to: PromotionRouteEnum.SecondDepositPromotion,
    packageId: PromotionPlanEnum.PROMOTION,
  },
  {
    name: 'Hoàn trả 1.2%',
    imgSrc: '/images/home/promotion/refund-promotion-modal.webp',
    imgSrcMB: '/images/home/promotion/refund-promotion-modal-mb.webp',
    to: PromotionRouteEnum.UnlimitedDepositPromotion,
    packageId: PromotionPlanEnum.COMMISSION,
  },
]

export const promotionDeposit: PromotionDeposit[] = [
  {
    packageId: PromotionPlanEnum.PROMOTION,
    title: 'Thưởng 70%',
    description: 'Nạp lần 2',
  },
  {
    packageId: PromotionPlanEnum.WELCOME,
    title: 'Thưởng 150%',
    description: 'Nạp lần đầu',
  },
  {
    packageId: PromotionPlanEnum.COMMISSION,
    title: 'Hoàn trả 1.2%',
    description: 'Không giới hạn',
  },
]

export const promotionBanners: PromotionBannerItem[] = [
  {
    packageId: PromotionIdEnum.NOHU,
    imgSrc: '/images/promotions/super-lottery.webp',
    imgSrcMb: '/images/promotions/super-lottery-mb.webp',
    imgBannerSrc: '/images/promotions/super-lottery-banner.webp',
    imgBannerSrcMb: '/images/promotions/super-lottery-banner-mb.webp',
    title: 'Mở bát nhận tiền',
    titleEvent: 'Khai trương hồng phát',
    note: 'Giải thưởng lên đến 2 tỷ đồng',
    description: 'Khai trương hồng phát',
    link: PromotionRouteEnum.SanSieuHutPromotion,
    isEvent: true,
    eventLink: RoutesEnum.EventDrawingLots,
  },
  {
    packageId: PromotionPlanEnum.WELCOME,
    imgSrc: '/images/promotions/first-cashback.webp',
    imgSrcMb: '/images/promotions/first-cashback-mb.webp',
    imgBannerSrc: '/images/promotions/first-cashback-banner.webp',
    imgBannerSrcMb: '/images/promotions/first-cashback-banner-mb.webp',
    title: 'Thưởng 150% lần nạp đầu tiên',
    note: 'Lên đến 20,000,000 VNĐ',
    description: 'Thưởng 150% nạp lần đầu',
    link: PromotionRouteEnum.FirstDepositPromotion,
    isHot: true,
  },
  {
    packageId: PromotionPlanEnum.PROMOTION,
    imgSrc: '/images/promotions/second-cashback.webp',
    imgSrcMb: '/images/promotions/second-cashback-mb.webp',
    imgBannerSrc: '/images/promotions/second-cashback-banner.webp',
    imgBannerSrcMb: '/images/promotions/second-cashback-banner-mb.webp',
    title: 'Thưởng 70% nạp lần 2',
    note: 'Lên đến 5,000,000 VNĐ',
    description: 'Khuyến mãi  70% nạp lần 2',
    link: PromotionRouteEnum.SecondDepositPromotion,
    isHot: true,
  },
  {
    packageId: PromotionPlanEnum.COMMISSION,
    imgSrc: '/images/promotions/unlimited-cashback.webp',
    imgSrcMb: '/images/promotions/unlimited-cashback-mb.webp',
    imgBannerSrc: '/images/promotions/unlimited-cashback-banner.webp',
    imgBannerSrcMb: '/images/promotions/unlimited-cashback-banner-mb.webp',
    title: 'Hoàn trả 1.2%',
    note: 'Không giới hạn',
    description: 'Hoàn trả 1.2% không giới hạn',
    link: PromotionRouteEnum.UnlimitedDepositPromotion,
    isNew: true,
  },
  {
    packageId: PromotionPlanEnum.COMMISSION,
    imgSrc: '/images/promotions/card_promotion_default.webp',
    imgSrcMb: '',
    imgBannerSrc: '/images/promotions/unlimited-cashback-banner.webp',
    imgBannerSrcMb: '/images/promotions/unlimited-cashback-banner-mb.webp',
    title: '--',
    note: '--',
    description: '',
    link: '',
    isComingSoon: true,
  },
  {
    packageId: PromotionPlanEnum.COMMISSION,
    imgSrc: '/images/promotions/card_promotion_default.webp',
    imgSrcMb: '',
    imgBannerSrc: '',
    imgBannerSrcMb: '',
    title: '--',
    note: '--',
    description: '',
    link: '',
    isComingSoon: true,
  },
  {
    packageId: PromotionPlanEnum.COMMISSION,
    imgSrc: '/images/promotions/card_promotion_default.webp',
    imgSrcMb: '',
    imgBannerSrc: '',
    imgBannerSrcMb: '',
    title: '--',
    note: '--',
    description: '',
    link: '',
    isComingSoon: true,
  },
]

export const promotionDetail = (brandName: string, unit: string, timeEvent?: string) => [
  {
    packageId: PromotionPlanEnum.WELCOME,
    content: `
    <div
    class="ctn-note"
    style="
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 16px;
      display: inline-flex;
    "
  >
    <div
      style="
        align-self: stretch;
        display: flex;
        flex-direction: column;
        gap: 16px;
      "
    >
      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >1.</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          Khuyến mãi này dành cho tất cả thành viên mới tại </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >${brandName}</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          thực hiện gửi tiền lần đầu.</span
        >
      </div>

      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >2. </span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Số tiền thưởng tối đa lên tới </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >20,000,000 ${unit}.</span
        >
      </div>

      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          3.
        </span>

        <span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          Cùng một thời điểm thành viên chỉ được tham gia duy nhất một
          chương trình khuyến mãi.</span
        >
      </div>

      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >4.</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          Khuyến mãi </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          150%</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          chỉ áp dụng cho sản phẩm </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Thể Thao, Thể Thao Ảo, Keno, Numbers Game và Slots Nổ Hũ</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >. Tiền gửi và tiền khuyến mãi cần trải qua </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >30 vòng cược</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          trước khi thực hiện rút tiền.
        </span>
      </div>

      <div>
        <span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Ví dụ: Quý khách nạp vào</span
        >
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          1,000,000 ${unit}</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >, Quý khách sẽ được nhận thêm </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
        >150% </span>
        <span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >tiền thưởng là </span>
          <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
        >1,500,000 ${unit}.</span>
        <span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          > Trong tài khoản của Quý khách sẽ có </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >2,500,000 ${unit}</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >. Khi đó, tổng tiền cược Quý khách cần hoàn thành là: </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >2,500,000 x 30 = 75,000,000 ${unit}</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >. Tổng tiền cược này được áp dụng cho các sản phẩm cược tại </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >${brandName}</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          gồm: </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Thể Thao, Thể Thao Ảo, Keno, Numbers Game và Slots Nổ Hũ.</span
        >
      </div>
      <ul style="list-style: disc; margin-left: 30px;x">
        <li style="color: #cdcdcd">
          <span
            style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
            "
            >Các sản phẩm tính </span
          ><span
            class="text-bold"
            style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            "
            >100% Doanh thu cược: Thể Thao (trừ K-Sports), Thể Thao
            Ảo.</span
          >
        </li>
        <li style="color: #cdcdcd">
          <span
            style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
            "
            >Các sản phẩm tính </span
          ><span
            class="text-bold"
            style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            "
            >30% Doanh thu cược: Slots Nổ Hũ, Numbers Game, K-Sports.</span
          >
        </li>
        <li style="color: #cdcdcd">
          <span
            style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
            "
            >Các sản phẩm tính </span
          ><span
            class="text-bold"
            style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            "
            >20% Doanh thu cược: Keno.</span
          >
        </li>
      </ul>
      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >5. </span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Tham gia khuyến mãi </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          150%</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          không chơi được </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Live Casino, inGame, Battle Games, Quay Số, Slots (trừ slots của nhà cung cấp Techplay), Game Bài, Đua Ngựa 3D.
        </span>
      </div>

      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
=            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >6.</span
        >
        <span
          style="
            color: #cdcdcd;
=            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Cược hòa, cược hai bên, cược hủy, cược vô hiệu, cược kiểu CN tỷ
          lệ dưới </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
=            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >0.5 (tương tự cho các kiểu cược khác như Malay odds dưới 0.5 ;
          Indo odds dưới -2.00 ; US odds dưới -200 và Dec odd dưới
          1.50)</span
        ><span
          style="
            color: #cdcdcd;
=            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          sẽ không được tính vào tổng tiền đặt cược.</span
        >
      </div>

      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >7.</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          Nghiêm cấm hành vi tạo nhiều tài khoản để trục lợi khuyến mãi,
          gian lận trong đặt cược, hoặc có sự hợp tác của một nhóm trong quá
          trình đặt cược. Chúng tôi có hệ thống giám sát và kiểm tra kèo
          cược chuyên nghiệp, </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >${brandName}</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          sẽ xử lý nghiêm đối với các trường hợp cá cược gian lận.</span
        >
      </div>
    </div>
    <div style="align-self: stretch">
      <span
        class="text-note"
        style="
          color: #ed9b5c;
          font-family: Inter;
          font-weight: 700;
          line-height: 24px;
          word-wrap: break-word;
        "
        >Lưu ý:<br /></span
      ><span
        style="
          color: #cdcdcd;
          font-family: Inter;
          font-weight: 400;
          line-height: 24px;
          word-wrap: break-word;
        "
        >Hệ thống tự động hủy khuyến mãi khi tài khoản Quý khách quá thời
        hạn </span
      ><span
        class="text-bold"
        style="
          color: #cdcdcd;
          font-family: Inter;
          font-weight: 700;
          line-height: 24px;
          word-wrap: break-word;
        "
        >30 ngày</span
      ><span
        style="
          color: #cdcdcd;
          font-family: Inter;
          font-weight: 400;
          line-height: 24px;
          word-wrap: break-word;
        "
      >
        hoàn thành khuyến mãi.<br />Nếu hủy khuyến mãi, tài khoản bị reset về </span
      ><span
        class="text-bold"
        style="
          color: #cdcdcd;
          font-family: Inter;
          font-weight: 700;
          line-height: 24px;
          word-wrap: break-word;
        "
        >0 K</span
      ><span
        style="
          color: #cdcdcd;
          font-family: Inter;
          font-weight: 400;
          line-height: 24px;
          word-wrap: break-word;
        "
        >. Quý khách lưu ý trước khi hủy hoặc liên hệ CSKH để được hỗ
        trợ.</span
      >
    </div>
  </div>
    `,
  },
  {
    packageId: PromotionPlanEnum.PROMOTION,
    content: `
    <div
    class="ctn-note"
    style="
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 24px;
      display: inline-flex;
    "
  >
    <div
      style="
        align-self: stretch;
        display: flex;
        flex-direction: column;
        gap: 16px;
      "
    >
      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >1.</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          Khuyến mãi này dành cho tất cả thành viên mới tại </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >${brandName}</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          thực hiện gửi tiền lần 2.</span
        >
      </div>

      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >2. </span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Số tiền thưởng tối đa lên tới </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >5,000,000 ${unit}.</span
        >
      </div>

      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          3.
        </span>

        <span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          Cùng một thời điểm thành viên chỉ được tham gia duy nhất một
          chương trình khuyến mãi.</span
        >
      </div>

      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >4.</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          Khuyến mãi </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          70%</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          chỉ áp dụng cho sản phẩm </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Thể Thao, Thể Thao Ảo, Keno, Numbers Game và Slots Nổ Hũ</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >. Tiền gửi và tiền khuyến mãi cần trải qua </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >15 vòng cược</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          trước khi thực hiện rút tiền.
        </span>
      </div>

      <div>
        <span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Ví dụ: Quý khách nạp vào</span
        >
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >1,000,000 ${unit}</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >, Quý khách sẽ được nhận thêm </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          70%</span
        >
        <span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          > tiền thưởng là</span>
          <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
        > 700,000 ${unit}.</span>
        <span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          > Trong tài khoản của Quý khách sẽ có </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >1,700,000 ${unit}</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >. Khi đó, tổng tiền cược Quý khách cần hoàn thành là: </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >1,700,000 x 15 = 25,500,000 ${unit}</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >. Tổng tiền cược này được áp dụng cho các sản phẩm cược tại </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >${brandName}</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          gồm: </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Thể Thao, Thể Thao Ảo, Keno, Numbers Game và Slots Nổ Hũ.</span
        >
      </div>
      <ul style="list-style: disc; margin-left: 30px;x">
        <li style="color: #cdcdcd">
          <span
            style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
            "
            >Các sản phẩm tính </span
          ><span
            class="text-bold"
            style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            "
            >100% Doanh thu cược: Thể Thao (trừ K-Sports), Thể Thao
            Ảo.</span
          >
        </li>
        <li style="color: #cdcdcd">
          <span
            style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
            "
            >Các sản phẩm tính </span
          ><span
            class="text-bold"
            style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            "
            >30% Doanh thu cược: Slots Nổ Hũ, Numbers Game, K-Sports.</span
          >
        </li>
        <li style="color: #cdcdcd">
          <span
            style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
            "
            >Các sản phẩm tính </span
          ><span
            class="text-bold"
            style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            "
            >20% Doanh thu cược: Keno.</span
          >
        </li>
      </ul>
      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >5. </span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Tham gia khuyến mãi </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          70%</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          không chơi được </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Live Casino, inGame, Battle Games, Quay Số, Slots (trừ slots của nhà cung cấp Techplay) Game Bài, Đua Ngựa 3D.
        </span>
      </div>

      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >6.</span
        >
        <span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
          >Cược hòa, cược hai bên, cược hủy, cược vô hiệu, cược kiểu CN tỷ
          lệ dưới </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >0.5 (tương tự cho các kiểu cược khác như Malay odds dưới 0.5 ;
          Indo odds dưới -2.00 ; US odds dưới -200 và Dec odd dưới
          1.50)</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          sẽ không được tính vào tổng tiền đặt cược.</span
        >
      </div>

      <div>
        <span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >7.</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          Nghiêm cấm hành vi tạo nhiều tài khoản để trục lợi khuyến mãi,
          gian lận trong đặt cược, hoặc có sự hợp tác của một nhóm trong quá
          trình đặt cược. Chúng tôi có hệ thống giám sát và kiểm tra kèo
          cược chuyên nghiệp, </span
        ><span
          class="text-bold"
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          "
          >${brandName}</span
        ><span
          style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          sẽ xử lý nghiêm đối với các trường hợp cá cược gian lận.</span
        >
      </div>
    </div>
    <div style="align-self: stretch">
      <span
        class="text-note"
        style="
          color: #ed9b5c;
          font-family: Inter;
          font-weight: 700;
          line-height: 24px;
          word-wrap: break-word;
        "
        >Lưu ý:<br /></span
      ><span
        style="
          color: #cdcdcd;
          font-family: Inter;
          font-weight: 400;
          line-height: 24px;
          word-wrap: break-word;
        "
        >Hệ thống tự động hủy khuyến mãi khi tài khoản Quý khách quá thời
        hạn </span
      ><span
        class="text-bold"
        style="
          color: #cdcdcd;
          font-family: Inter;
          font-weight: 700;
          line-height: 24px;
          word-wrap: break-word;
        "
        >30 ngày</span
      ><span
        style="
          color: #cdcdcd;
          font-family: Inter;
          font-weight: 400;
          line-height: 24px;
          word-wrap: break-word;
        "
      >
        hoàn thành khuyến mãi.<br />Nếu hủy khuyến mãi, tài khoản bị reset về </span
      ><span
        class="text-bold"
        style="
          color: #cdcdcd;
          font-family: Inter;
          font-weight: 700;
          line-height: 24px;
          word-wrap: break-word;
        "
        >0 K</span
      ><span
        style="
          color: #cdcdcd;
          font-family: Inter;
          font-weight: 400;
          line-height: 24px;
          word-wrap: break-word;
        "
        >. Quý khách lưu ý trước khi hủy hoặc liên hệ CSKH để được hỗ
        trợ.</span
      >
    </div>
  </div>
    `,
  },
  {
    packageId: PromotionPlanEnum.COMMISSION,
    content: `
        <div
         style="
            align-self: stretch;
            display: flex;
            flex-direction: column;
            gap: 16px;
            "
        >
          <div>
            <span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >1.
            </span>
            <span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >Khuyến mãi này dành cho tất cả thành viên.
            </span>
          </div>
          <div>
            <span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >2. </span
              ><span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >Số tiền thưởng tối đa
            </span>
            <span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >Không giới hạn.</span
              >
          </div>
          <div>
            <span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >3. </span
              ><span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >Cùng một thời điểm thành viên chỉ được tham gia duy nhất một chương
            trình khuyến mãi.</span
              >
          </div>
          <div>
            <span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >4. </span
              ><span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >Khuyến mãi cược </span
              ><span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >1.2%</span
              ><span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >
            chỉ áp dụng cho sản phẩm </span
              ><span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >Thể Thao, Thể Thao Ảo, Keno, Numbers Game, Slots Nổ Hũ, Đua Ngựa
            3D.</span
              >
          </div>
          <ul style="list-style: disc; margin-left: 30px; margin-bottom: 8px">
            <li style="color: #cdcdcd">
              <span
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 400;
                line-height: 24px;
                word-wrap: break-word;
                "
                >Các sản phẩm tính </span
                ><span
                class="text-bold"
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 700;
                line-height: 24px;
                word-wrap: break-word;
                "
                >100% Doanh thu cược: Thể Thao (trừ K-Sports), Thể Thao Ảo.<br
                /></span>
            </li>
            <li style="color: #cdcdcd">
              <span
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 400;
                line-height: 24px;
                word-wrap: break-word;
                "
                >Các sản phẩm tính </span
                ><span
                class="text-bold"
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 700;
                line-height: 24px;
                word-wrap: break-word;
                "
                >30% Doanh thu cược: Slots Nổ Hũ, Numbers Game, Đua Ngựa 3D,
              K-Sports.<br
                /></span>
            </li>
            <li style="color: #cdcdcd">
              <span
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 400;
                line-height: 24px;
                word-wrap: break-word;
                "
                >Các sản phẩm tính </span
                ><span
                class="text-bold"
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 700;
                line-height: 24px;
                word-wrap: break-word;
                "
                >20% Doanh thu cược: Keno.<br
                /></span>
            </li>
          </ul>
          <div>
            <span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >Ví dụ: Quý khách cược </span
              ><span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >10,000,000 ${unit}</span
              ><span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >
            các sản phẩm tính </span
              ><span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >100%</span
              ><span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >
            doanh thu sẽ được khuyến mãi siêu hoàn trả như sau: </span
              ><span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >10,000,000 ${unit} x 1.2% = 120,000 ${unit}.</span
              ><br /><span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              > Quý khách cược </span
              ><span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >10,000,000 ${unit}</span
              ><span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >
            các sản phẩm tính </span
              ><span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >30%</span
              ><span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >
            doanh thu sẽ được khuyến mãi siêu hoàn trả như sau: </span
              ><span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >10,000,000 ${unit} x 30% x 1.2% = 36,000 ${unit}.</span
              >
          </div>
          <ul style="list-style: disc; margin-left: 30px; margin-bottom: 8px">
            <li style="color: #cdcdcd">
              <span
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 400;
                line-height: 24px;
                word-wrap: break-word;
                "
                >Chương trình được </span
                ><span
                class="text-bold"
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 700;
                line-height: 24px;
                word-wrap: break-word;
                "
                >áp dụng vô tận</span
                ><span
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 400;
                line-height: 24px;
                word-wrap: break-word;
                "
                >, khi Quý khách đặt cược sẽ có cơ hội </span
                ><span
                class="text-bold"
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 700;
                line-height: 24px;
                word-wrap: break-word;
                "
                >nhận tiền hoàn trả, không giới hạn về số tiền cược.</span
                >
            </li>
            <li style="color: #cdcdcd">
              <span
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 400;
                line-height: 24px;
                word-wrap: break-word;
                "
                >Thưởng </span
                ><span
                class="text-bold"
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 700;
                line-height: 24px;
                word-wrap: break-word;
                "
                >hoàn trả</span
                ><span
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 400;
                line-height: 24px;
                word-wrap: break-word;
                "
                >
              sẽ được cập nhật vào tài khoản của Quý khách vào lúc </span
                ><span
                class="text-bold"
                style="
                color: #cdcdcd;
                font-family: Inter;
                font-weight: 700;
                line-height: 24px;
                word-wrap: break-word;
                "
                >11h45 hằng ngày.</span
                >
            </li>
          </ul>
          <div>
            <span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >5. </span
              ><span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >Cược hòa, cược hai bên, cược hủy, cược vô hiệu, cược kiểu CN tỷ lệ dưới 0.5</span
              ><span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >
            0.5 (tương tự cho các kiểu cược khác như Malay odds dưới 0.5 ; Indo odds dưới -2.00 ; US odds dưới -200 và Dec odds dưới 1.50)</span
              ><span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >
            sẽ không được tính vào tổng tiền đặt cược.</span
              >
          </div>
          <div style="margin-bottom: 0">
            <span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >6. </span
              >
            <span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >Nghiêm cấm hành vi tạo nhiều tài khoản để trục lợi khuyến mãi, gian
            lận trong đặt cược, hoặc có sự hợp tác của một nhóm trong quá trình
            đặt cược. Chúng tôi có hệ thống giám sát và kiểm tra kèo cược chuyên
            nghiệp, </span
              ><span
              class="text-bold"
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
              "
              >${brandName}</span
              ><span
              style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
              "
              >
            sẽ xử lý nghiêm đối với các trường hợp cá cược gian lận.</span
              >
          </div>
        </div>
    `,
  },
  {
    packageId: PromotionIdEnum.NOHU,
    content: `<div class="ctn-note" style="
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
    display: inline-flex;
  ">
  <div style="
        align-self: stretch;
        display: flex;
        flex-direction: column;
        gap: 16px;
      ">
    <div style="color: #cdcdcd">
      <span style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          ">
        Chào mừng Quý khách đến với chương trình
      </span>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
        "Khai Trương Hồng Phát, Mở Bát Nhận Tiền"</span>
      của
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
        ${brandName}</span>.
    </div>

    <div>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
        1.
      </span>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
        Thời gian diễn ra chương trình
      </span>
    </div>

    <div style="color: #cdcdcd">
      <span style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          ">
        Chương trình rút thăm may mắn sẽ diễn ra từ ngày
      </span>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
          ${timeEvent?.split(' - ')[0]}
      </span>
      <span style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
          ">
        đến ngày
      </span>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
        ${timeEvent?.split(' - ')[1]}.
      </span>
    </div>

    <div>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
        2.
      </span>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
        Điều kiện tham gia
      </span>
    </div>
    <ul style="list-style: disc; margin-left: 30px">
      <li style="color: #cdcdcd">
        <span class="text-bold" style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            ">
          Mỗi ngày</span><span style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 400;
              line-height: 24px;
              word-wrap: break-word;
            ">, Quý khách sẽ nhận được
        </span>
        <span class="text-bold" style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            ">
          1 lượt rút thăm may mắn
        </span>
        miễn phí khi đạt tổng số tiền cược
        <span class="text-bold" style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            ">
          5,000,000 ${unit}
        </span>
        trên bất kỳ sản phẩm nào của
        <span class="text-bold" style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            ">
          ${brandName}</span>.
      </li>

      <li style="color: #cdcdcd">
        Lượt rút thăm miễn phí chỉ có giá trị trong ngày và không cộng dồn vào
        các ngày tiếp theo.
      </li>
    </ul>
    <div>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
        3.
      </span>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
        Giải thưởng
      </span>
    </div>
    <ul style="list-style: disc; margin-left: 30px">
      <li style="color: #cdcdcd">
        Quý khách có cơ hội nhận các phần quà may mắn với giá trị từ 
        <span class="text-bold" style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            ">
          868 ${unit}
        </span>
        đến
        <span class="text-bold" style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            ">
          9,999,999 ${unit}
        </span>
      </li>
      <li style="color: #cdcdcd">
        Số tiền thưởng sẽ được chuyển trực tiếp vào ví của Quý khách trong vòng <span class="text-bold" style="
        color: #cdcdcd;
        font-family: Inter;
        font-weight: 700;
        line-height: 24px;
        word-wrap: break-word;
      ">48 giờ</span> kể từ khi nhận thưởng.
      </li>
    </ul>
    <div>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
        4.
      </span>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
         Điều kiện áp dụng
      </span>
    </div>
    <div style="
    color: #cdcdcd;
    font-family: Inter;
    font-weight: 400;
    line-height: 24px;
    word-wrap: break-word;
  ">Chương trình không áp dụng cho:</div>

    <ul style="list-style: disc; margin-left: 30px">
      <li style="color: #cdcdcd">
        Khuyến mãi 
        <span class="text-bold" style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            ">
         150% nạp lần đầu</span>.
      </li>
      <li style="color: #cdcdcd">
        Khuyến mãi 
        <span class="text-bold" style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            ">
         70% nạp lần thứ 2</span>.
      </li>
      <li style="color: #cdcdcd">
        Các vé cược đã bị 
        <span class="text-bold" style="
              color: #cdcdcd;
              font-family: Inter;
              font-weight: 700;
              line-height: 24px;
              word-wrap: break-word;
            ">
         hủy, cược hòa, cược 2 bên, hoặc cược thấp không hợp lệ</span>.
      </li>
    </ul>
    <div>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
        5.
      </span>
      <span class="text-bold" style="
            color: #cdcdcd;
            font-family: Inter;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
          ">
         Điều kiện rút tiền thưởng
      </span>
    </div>
    <div style="
    color: #cdcdcd;
    font-family: Inter;
    font-weight: 400;
    line-height: 24px;
    word-wrap: break-word;
  ">Quý khách cần hoàn thành 1 vòng cược để có thể rút được tiền thưởng.</div>
  </div>
  <div>
    <span class="text-bold" style="
          color: #cdcdcd;
          font-family: Inter;
          font-weight: 700;
          line-height: 24px;
          word-wrap: break-word;
        ">
      6.
    </span>
    <span class="text-bold" style="
          color: #cdcdcd;
          font-family: Inter;
          font-weight: 700;
          line-height: 24px;
          word-wrap: break-word;
        ">
       Điều khoản bổ sung
    </span>
  </div>
  <div style="
  color: #cdcdcd;
  font-family: Inter;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
"><span class="text-bold" style="
color: #cdcdcd;
font-family: Inter;
font-weight: 700;
line-height: 24px;
word-wrap: break-word;
">
${brandName}
</span> có quyền sửa đổi, từ chối, hoặc thu hồi giải thưởng nếu phát hiện nghi vấn gian lận mà không cần thông báo trước.</div>
</div>
</div>
    `,
  },
]
